import { AppState, AppStore, createStore } from '@/redux/create-store';
import { GetServerSidePropsContext } from 'next';

import { isSSR } from '@/utils/millesimaUtils';

let store: AppStore | undefined = undefined;

type InitializeStoreParams = {
  preloadedState?: AppState,
  ssrContext?: GetServerSidePropsContext
}

export function initializeStore({ preloadedState = {} as AppState, ssrContext } : InitializeStoreParams): AppStore {
  if (isSSR()) {
    return createStore(preloadedState, ssrContext);
  }

  const _store = store ?? createStore(preloadedState, ssrContext);

  if (!store) {
    store = _store;
  }

  return _store;
}
